import React, { Component, createRef } from "react";
import { gsap } from "gsap";
import "./Scene10.css";
import box1 from "../../Resources/box-blog.jpeg";
import box2 from "../../Resources/box-eterxperience.jpeg";
import box3 from "../../Resources/box-playable-ads.jpeg";
import box4 from "../../Resources/whitepapers-landing/boxWP.png";
import bpotg from "../../Resources/icons/be-part-of-the-game.svg";
import MaxButton from "../MaxButton";
import SlideItem from "../SlideItem";
import "flag-icon-css/css/flag-icon.css";
import { injectIntl } from "react-intl";
import CircleText from "../CircleText";
import MaxFooter from "../Footer";
import { cw, getFM } from "../../Utilities/utils";
import BgGrid from "../BgGrid";
import { Atom360Fragment, MenuIcons } from "../menu/MenuIcons";
import { logEvent } from "../../Utilities/AmplitudeService";

const addSniffer = (limit) => {
  window.addEventListener("scroll", function (e) {
    if (window.scrollY >= limit) {
      window.scrollTo({ left: 0, top: limit, behavior: "smooth" });
    }
  });
};

class Scene10 extends Component {
  constructor(props) {
    super(props);
    this.scene10 = createRef();
    this.s10 = createRef();
    this.s11 = createRef();
    this.line1 = createRef();
    this.line2 = createRef();
    this.txt1 = createRef();
    this.txt2 = createRef();
    this.textContainer = createRef();
  }

  componentDidMount() {
    let s10w = this.s10.current.offsetWidth * -1;

    let line1Top = this.txt1.current.offsetTop;
    let line2Top = this.txt2.current.offsetTop;
    let yu = document.getElementById("s10bg1H").getAttribute("y1");

    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.scene10.current,
          start: "top 20%",
          scrub: true,
          end: "+=20%",
        },
      })
      .fromTo(
        this.line1.current,
        {
          top: line1Top,
          left: "-12vw",
          width: 0,
        },
        {
          top: line1Top,
          left: "-12vw",
          width: cw(this.txt1, this.textContainer, "marginLeft"),
          duration: 2,
        },
        "0"
      )
      .fromTo(
        this.line2.current,
        {
          top: line2Top,
          left: "-12vw",
          width: 0,
        },
        {
          top: line2Top,
          left: "-12vw",
          width: cw(this.txt2, this.textContainer, "marginLeft"),
          duration: 2,
        },
        "-=1"
      );

    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.scene10.current,
          start: "top top",
          pin: true,
          scrub: true,
          end: "+=250%",
          onLeave: () => {
            logEvent("footer_loader");
            addSniffer(window.scrollY);
          },
        },
      })
      .from(
        "#s10bg",
        {
          opacity: 0,
          duration: 0.05,
        },
        "0"
      )
      .fromTo(
        "#s8bg",
        {
          opacity: 1,
        },
        {
          opacity: 0,
          duration: 0.1,
        },
        "0"
      )
      .from(
        ["#s10ocV", "#s10ocH", "#s10rcV", "#s10rcH"],
        {
          duration: 1,
          attr: { y1: "-=" + yu * 2, y2: "-=" + yu * 2 },
        },
        "0.1"
      )
      .to(
        "#s10bg",
        {
          x: -1 * s10w,
          ease: "none",
          duration: 22,
        },
        "0"
      )
      .to(
        this.scene10.current,
        {
          x: s10w,
          ease: "none",
          duration: 22,
        },
        "0"
      )
      .to(
        ".s11-bpotg",
        {
          //            ease: "power1.easeInOut",
          scaleX: 50,
          scaleY: 50,
          duration: 7,
        },
        "22.5"
      )
      .to(".s11-bpotg", {
        //            ease: "power1.easeInOut",
        display: "none",
        duration: 0.5,
      })
      .from(
        ".s11-text",
        {
          //          ease: "power1.easeIn",
          stagger: 1,
          opacity: 0,
          duration: 4,
          onReverseComplete: () => {
            gsap.set(MenuIcons, {
              boxShadow: "var(--iconShadow) black",
              color: "black",
            });
          },
          onComplete: () => {
            gsap.set(MenuIcons, {
              boxShadow: "var(--iconShadow) white",
              color: "white",
            });
          },
        },
        "23"
      )
      .to(this.s11.current, {
        y: "-=60vh",
        duration: 4,
        scrub: true,
      });
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.scene10.current,
          start: "top top",
          scrub: true,
          end: "+=400%",
        },
      })
      .to("#logoX", {
        duration: 2,
        opacity: 1,
        color: "white",
      });
  }

  render() {
    return (
      <section ref={this.scene10} className={"s10-s11-container"}>
        <BgGrid
          id="s10bg"
          className={"s10-bg"}
          vLines={7}
          hLines={5}
          stroke={"#888888"}
          shapes={[
            { id: "s10rc", shape: "+", x: 2, y: 4, size: 6, color: "red" },
            { id: "s10oc", shape: "+", x: 6, y: 1, size: 6, color: "orange" },
          ]}
        />
        <section ref={this.s10} className={"s10-container"}>
          <div className={"s10-container s10-content"}>
            <h1 ref={this.textContainer} className={"s10-text-container"}>
              <div
                ref={this.line1}
                className={"underline orange accessibility-line"}
              />
              <span className={"s10-text"}>
                {getFM("home_carrousel_title")}
              </span>
              <span ref={this.txt1} className={"s10-text"}>
                {getFM("home_carrousel_title_2")}
              </span>
              <span ref={this.txt2} className={"s10-text"}>
                {getFM("home_carrousel_title_3")}
              </span>
              <div
                ref={this.line2}
                className={"underline orange accessibility-line"}
              />
            </h1>
            <SlideItem
              id={"blog-item"}
              title={["home_carrousel_blog_title"]}
              subTitle={[
                "home_carrousel_blog_txt",
                "home_carrousel_blog_txt_2",
              ]}
              bgImage={box1}
              clickable={true}
              clickEvent={() => {
                logEvent("news");
                window.open(
                  "https://www.etermax.com/es/news/search",
                  "_blank"
                );
              }}
            />
            <SlideItem
              id={"360-item"}
              title={["home_carrousel_360_title"]}
              subTitle={["home_carrousel_360_txt", "home_carrousel_360_txt_2"]}
              bgImage={box2}
              clickable={true}
              clickEvent={() =>
                window.open("https://etermax.com/eterXperience")
              }
            >
              <div className={"tour360"}>
                <CircleText
                  cMargin={10}
                  className={"s10-circle"}
                  classText={"circle-text"}
                  title={
                    "• " +
                    this.props.intl.formatMessage({
                      id: "home_carrousel_360_button",
                    }) +
                    " •"
                  }
                  clickEvent={() => {
                    logEvent("eterXperience");
                    window.open("https://etermax.com/eterXperience");
                  }}
                >
                  <React.Fragment>{Atom360Fragment(10)}</React.Fragment>
                </CircleText>
              </div>
            </SlideItem>
            <SlideItem
              id={"showcase-item"}
              title={["home_carrousel_showcase_title"]}
              subTitle={[
                "home_carrousel_showcase_txt",
                "home_carrousel_showcase_txt_2",
              ]}
              clickable={true}
              bgImage={box3}
              clickEvent={() => {
                logEvent("showCase");
                window.open("https://showcase.etermax.com");
              }}
            />
            <SlideItem
              id={"whitePaper-item"}
              title={["home_carrousel_whitePaper_title"]}
              subTitle={[
                "home_carrousel_whitePaper_subtitle",
                "home_carrousel_whitePaper_subtitle1",
              ]}
              clickable={false}
              bgImage={box4}
              footer={
                <MaxButton clickRoute={"whitepapers"} bgColor={"#00D689"}>
                  home_learn_more_button
                </MaxButton>
              }
            />
            {/* <SlideItem id={'insight-item'}
                               className={"slide-item insightItem"}
                               title={['home_carrousel_subscription_title']}
                               titleColor='#624CBF'
                               subTitle={["home_carrousel_subscription_txt",
                                   "home_carrousel_subscription_txt_2"]}
                               bgImage={insight}
                               footer={<MailCountry
                                                    className={"form-area accessibility-img"}
                                                    hideOnSubscription={['#insight-item-title',
                                                        '#insight-item-subtitle']}
                               />}
                    >
                        <div className={"insight-top"}/>
                    </SlideItem>*/}
          </div>
        </section>
        <div ref={this.s11} className={"s11-with-footer"}>
          <div className={"s11-element accessibility-img"}>
            <div className={"s11-s10-trans"} />
            <img
              className={"s11-bpotg accessibility-img"}
              src={bpotg}
              alt="Be Part of the Game"
            />
            <div className={"s11-text-container"}>
              <h3>
                <div className={"s11-text"}>
                  {getFM("home_start_planning_txt")}
                </div>
                <div className={"s11-text"}>
                  {getFM("home_start_planning_txt_2")}
                </div>
              </h3>
              <div className={"s11-text left "}>
                <MaxButton clickRoute={"contact"}>
                  home_start_planning_button
                </MaxButton>
              </div>
            </div>
          </div>
          <MaxFooter contactsPath={`./contact`} />
        </div>
      </section>
    );
  }
}
export default injectIntl(Scene10);
